export const FETCH_CARE_ROUND_TYPE = "app/CareRoundType/FETCH_CARE_ROUND_TYPE";
export const FETCH_CARE_ROUND_TYPE_SUCCESS =
  "app/CareRoundType/FETCH_CARE_ROUND_TYPE_SUCCESS";
export const FETCH_CARE_ROUND_TYPE_FAILURE =
  "app/CareRoundType/FETCH_CARE_ROUND_TYPE_FAILURE";

export const SEARCH_CARE_ROUND_TYPE =
  "app/CareRoundType/SEARCH_CARE_ROUND_TYPE";
export const SEARCH_CARE_ROUND_TYPE_SUCCESS =
  "app/CareRoundType/SEARCH_CARE_ROUND_TYPE_SUCCESS";
export const SEARCH_CARE_ROUND_TYPE_FAILURE =
  "app/CareRoundType/SEARCH_CARE_ROUND_TYPE_FAILURE";

export const ADD_CARE_ROUND_TYPE = "app/CareRoundType/ADD_CARE_ROUND_TYPE";
export const ADD_CARE_ROUND_TYPE_SUCCESS =
  "app/CareRoundType/ADD_CARE_ROUND_TYPE_SUCCESS";
export const ADD_CARE_ROUND_TYPE_FAILURE =
  "app/CareRoundType/ADD_CARE_ROUND_TYPE_FAILURE";

export const FETCH_CARE_ROUND_TYPE_ITEM =
  "app/CareRoundType/FETCH_CARE_ROUND_TYPE_ITEM";
export const FETCH_CARE_ROUND_TYPE_ITEM_SUCCESS =
  "app/CareRoundType/FETCH_CARE_ROUND_TYPE_ITEM_SUCCESS";
export const FETCH_CARE_ROUND_TYPE_ITEM_FAILURE =
  "app/CareRoundType/FETCH_CARE_ROUND_TYPE_ITEM_FAILURE";

export const EDIT_CARE_ROUND_TYPE = "app/CareRoundType/EDIT_CARE_ROUND_TYPE";
export const EDIT_CARE_ROUND_TYPE_SUCCESS =
  "app/CareRoundType/EDIT_CARE_ROUND_TYPE_SUCCESS";
export const EDIT_CARE_ROUND_TYPE_FAILURE =
  "app/CareRoundType/EDIT_CARE_ROUND_TYPE_FAILURE";

export const DELETE_CARE_ROUND_TYPE =
  "app/CareRoundType/DELETE_CARE_ROUND_TYPE";
export const DELETE_CARE_ROUND_TYPE_SUCCESS =
  "app/CareRoundType/DELETE_CARE_ROUND_TYPE_SUCCESS";
export const DELETE_CARE_ROUND_TYPE_FAILURE =
  "app/CareRoundType/DELETE_CARE_ROUND_TYPE_FAILURE";

export const SET_CARE_ROUND_TYPE_ADD_EDIT_MODAL =
  "app/CareRoundType/SET_CARE_ROUND_TYPE_ADD_EDIT_MODAL";
